import { h, Host } from "@stencil/core";
export class GalleryImage {
    constructor() {
        this.zoom = 1;
    }
    render() {
        const style = {
            transition: 'none',
            transform: `scale(${this.zoom})`,
        };
        if (this.transition) {
            style.transition = 'all 350ms';
        }
        if (this.translateCoordinates) {
            style.transform += ` translate(${this.translateCoordinates.x}px, ${this.translateCoordinates.y}px)`;
        }
        return (h(Host, { key: 'a18ad89f239976c511026647136d1cdcfa810f25', class: { active: this.active } }, h("img", { key: 'bd94d86643aba67a5c207ad3f6c286a481da3758', src: this.image, alt: "", class: "img-fluid", style: style })));
    }
    static get is() { return "uvex-gallery-image"; }
    static get properties() {
        return {
            "image": {
                "type": "string",
                "attribute": "image",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "active": {
                "type": "boolean",
                "attribute": "active",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "zoom": {
                "type": "number",
                "attribute": "zoom",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false,
                "defaultValue": "1"
            },
            "transition": {
                "type": "boolean",
                "attribute": "transition",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "reflect": false
            },
            "translateCoordinates": {
                "type": "unknown",
                "attribute": "translate",
                "mutable": false,
                "complexType": {
                    "original": "{ x: number, y: number }",
                    "resolved": "{ x: number; y: number; }",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false
            }
        };
    }
}
//# sourceMappingURL=gallery-image.js.map
